export enum DialogTitleAlignEnum {
    LEFT = 'left',
    CENTER = 'center',
}

export type DialogTitleAlignEnumValues = `${DialogTitleAlignEnum}`